export default "__VITE_ASSET__8db53125__"